import _ from "lodash";
export class InvoiceServices {
    lines; //: InvoiceLine[]
    lSign;
    vatType;
    discount;
    discountPercentage;
    defaultSalesAccountableAccount;
    quotation;
    constructor(
        lines,
        lSign,
        vatType,
        discount,
        discountPercentage,
        defaultSalesAccountableAccount,
        quotation
    ) {
        this.lines = lines;
        this.lSign = lSign;
        this.vatType = vatType;
        this.discount = discount;
        this.discountPercentage = discountPercentage;
        this.defaultSalesAccountableAccount = defaultSalesAccountableAccount;
        this.quotation = quotation;
    }

    // getLineValues(line) {
    //     const result = {
    //         netAmount: 0,
    //         vatAmount: 0,
    //         grossAmount: 0
    //     }
    //     if (!line) {
    //         debugger
    //         return result
    //     }
    //     if (line.type === "PRODUCT") {

    //     } else if (line.type === "DEPOSIT") {
    //         const unsignedAccountingSubAmounts = this.getDepositValues(line)
    //         for (const subAmount of unsignedAccountingSubAmounts) {
    //             result.netAmount += subAmount.netAmountSigned || 0
    //             result.vatAmount += subAmount.vatAmountSigned || 0
    //         }
    //         result.grossAmount = result.netAmount + result.vatAmount

    //     } else if (line.type === "TOTAL") {
    //     } else {
    //         debugger
    //     }

    //     return result

    // }

    getDepositValues(depositLine) {
        if (!this.quotation) {
            return [];
        }
        const quotationLines = this.quotation?.lines ? this.quotation.lines : [];
        const invoiceServices = new InvoiceServices(
            quotationLines,
            this.lSign,
            this.vatType,
            this.quotation.discount,
            this.quotation.discountPercentage,
            this.defaultSalesAccountableAccount,
            undefined
        );
        const unsignedAccountingSubAmounts = invoiceServices.computation.accountingSubAmounts;

        const percentage = Math.abs(depositLine.grossAmount / invoiceServices.grossAmountTotal);
        for (const subAmount of unsignedAccountingSubAmounts) {
            if (subAmount.netAmount) {
                subAmount.netAmount *= percentage;
            }
            if (subAmount.vatAmount) {
                subAmount.vatAmount *= percentage;
            }
        }
        return unsignedAccountingSubAmounts;
    }

    getAsQuotationDepositValues(grossAmount: number) {
        const unsignedAccountingSubAmounts = this.computation.accountingSubAmounts;

        const percentage = Math.abs(grossAmount / this.grossAmountTotal);
        const result = {
            netAmount: 0,
            vatAmount: 0,
            discount: 0,
        };

        for (const subAmount of unsignedAccountingSubAmounts) {
            if (subAmount.netAmount) {
                result.netAmount += subAmount.netAmount * percentage;
            }
            if (subAmount.vatAmount) {
                result.vatAmount += subAmount.vatAmount * percentage;
            }
            if (subAmount.accountableAccount === "709") {
                result.discount += subAmount.netAmount * percentage;
            }
        }
        // result.grossAmount = result.netAmount + result.netAmount
        return result;
    }

    get computation() {
        let output = {
            accountingSubAmounts: [],
            totals: {},
        };
        let totalNetAmount = 0;
        for (const line of this.lines) {
            totalNetAmount += line.netAmount;
        }
        let index = 0;
        const netAmountPercentages = new Array(this.lines.length).fill(0);
        if (totalNetAmount) {
            for (const line of this.lines) {
                // line.netAmountPercentage = line.netAmount / totalNetAmount
                netAmountPercentages[index] = line.netAmount / totalNetAmount;
                index++;
            }
        }
        index = 0;
        const totals = {
            netAmount: 0,
            vatAmount: 0,
        };
        for (const line of this.lines) {
            if (line.type === "PRODUCT" && !line.isOptional) {
                const accountableAccount =
                    line.product?.accountableAccount?.name || this.defaultSalesAccountableAccount;
                let key = accountableAccount;
                if (accountableAccount !== "709" || !line.product?.percentage) {
                    let vatKey = "";
                    if (line.vatRate !== undefined && line.vatRate !== null) {
                        vatKey += "_" + line.vatRate;
                    }
                    let lineVatType;
                    if (line.vatRate === 0) {
                        lineVatType = this.vatType;
                        vatKey += "_" + lineVatType;
                    }
                    key += vatKey;
                    //c
                    let tagId;
                    if (line.product?.tagId) {
                        tagId = line.product.tagId;
                        key += "_" + tagId;
                    }
                    const vatAmount = (line.netAmount * line.vatRate) / 100;
                    let subAmount = output.accountingSubAmounts.find((sa) => sa.key === key);
                    if (!subAmount) {
                        const subAmount = {
                            key,
                            vatRate: line.vatRate,
                            vatType: lineVatType,
                            netAmount: line.netAmount,
                            vatAmount,
                            // grossAmount: line.grossAmount,
                            accountableAccount,
                            tagId,
                            isOptional: line.isOptional || false,
                        };
                        output.accountingSubAmounts.push(subAmount);
                    } else {
                        subAmount.netAmount += line.netAmount;
                        subAmount.vatAmount += vatAmount;
                    }
                    if (!line.isOptional) {
                        totals.netAmount += line.netAmount;
                        totals.vatAmount += vatAmount;
                    }
                    //
                    // discount
                    //
                    if (
                        this.discount ||
                        this.discountPercentage ||
                        line.discount ||
                        line.discountPercentage
                    ) {
                        const discountKey = "709" + vatKey;
                        subAmount = output.accountingSubAmounts.find(
                            (sa) => sa.key === discountKey
                        );
                        let netAmount = 0;
                        // local
                        if (line.discountPercentage) {
                            // line.discountPercentageAmount = line.netAmount * line.discountPercentage / 100
                            netAmount = (-line.netAmount * line.discountPercentage) / 100;
                        } else if (line.discount) {
                            netAmount = -line.discount;
                        }
                        // global
                        if (this.discountPercentage) {
                            netAmount +=
                                ((-line.netAmount - netAmount) * this.discountPercentage) / 100;
                        } else if (this.discount) {
                            netAmount -= this.discount * netAmountPercentages[index];
                        }
                        const vatAmount = (netAmount * line.vatRate) / 100;
                        if (!subAmount) {
                            const subAmount = {
                                key: discountKey,
                                vatRate: line.vatRate,
                                vatType: lineVatType,
                                netAmount,
                                vatAmount,
                                accountableAccount: "709",
                                isOptional: line.isOptional || false,
                            };
                            output.accountingSubAmounts.push(subAmount);
                        } else {
                            subAmount.netAmount += netAmount;
                            subAmount.vatAmount += vatAmount;
                        }
                        if (!line.isOptional) {
                            totals.netAmount += netAmount;
                            totals.vatAmount += vatAmount;
                        }
                    }
                } else {
                    debugger; // obsolete
                }
            } else if (line.type === "DEPOSIT") {
                output.accountingSubAmounts.push(...this.getDepositValues(line));
            } else if (line.type === "TOTAL") {
                output.totals[index] = _.cloneDeep(totals);
                totals.netAmount = 0;
                totals.vatAmount = 0;
            } else {
                // debugger
            }

            index++;
        }
        output.accountingSubAmounts.sort((a, b) => {
            if (a.accountableAccount === "709" && b.accountableAccount !== "709") return 1;
            if (a.accountableAccount !== "709" && b.accountableAccount === "709") return -1;
            return 0;
        });
        for (const subAmount of output.accountingSubAmounts) {
            subAmount.netAmount = this.lSign * subAmount.netAmount;
            subAmount.vatAmount = this.lSign * subAmount.vatAmount;
        }
        return output;
    }

    get accountingSubAmounts() {
        let output = [];

        if (this.computation.accountingSubAmounts.length) {
            for (const subAmount of this.computation.accountingSubAmounts) {
                output.push({
                    // grossAmount: grossAmount,
                    netAmountSigned: -subAmount.netAmount,
                    vatAmountSigned: -subAmount.vatAmount,
                    vatRate: subAmount.vatRate,
                    vatType: subAmount.vatType,
                    accountableAccount: subAmount.accountableAccount,
                    tagId: subAmount.tagId,
                });
            }
        }
        return output;
    }

    get subAmounts() {
        const subAmounts = [];
        for (const line of this.accountingSubAmounts) {
            // const accountableAccount = line.product?.accountableAccount?.name
            // let key = accountableAccount
            let key = "";
            if (line.vatRate !== undefined && line.vatRate !== null) {
                key = line.vatRate;
            }
            let vatType = "";
            if (line.vatRate === 0) {
                vatType = line.vatType || "NO_VAT_TYPE";
                key += "_" + vatType;
            }
            let subAmount = subAmounts.find((sa) => sa.key === key);
            if (!subAmount) {
                subAmounts.push({
                    key,
                    vatRate: line.vatRate,
                    vatType: vatType,
                    netAmount: line.netAmountSigned,
                    vatAmount: line.vatAmountSigned,
                });
            } else {
                subAmount.netAmount += line.netAmountSigned;
                subAmount.vatAmount += line.vatAmountSigned;
            }
        }
        return subAmounts;
    }

    get netAmountTotal() {
        let total = 0;
        for (const subAmount of this.accountingSubAmounts) {
            // condition sur les subAmounts ??? si !optional  ???
            total += subAmount.netAmountSigned;
        }
        return total;
    }
    get vatAmountTotals() {
        let totalsArray = this.subAmounts.map((sA) => ({
            vatRate: sA.vatRate,
            vatAmount: sA.vatAmount,
            netAmount: sA.netAmount,
        }));
        totalsArray.sort((a, b) => a.vatRate - b.vatRate);
        return totalsArray;
    }
    get vatAmountTotal() {
        let total = 0;
        for (const subAmount of this.accountingSubAmounts) {
            total += subAmount.vatAmountSigned;
        }
        return total;
    }
    get grossAmountTotal() {
        return this.netAmountTotal + this.vatAmountTotal;
    }
}

export function fromHT_UnitPriceToTTC(line) {
    // not implemented yet
    const t = line.unitPrice + (line.unitPrice * line.vatRate) / 100;
    debugger;
    return line.unitPrice + (line.unitPrice * line.vatRate) / 100;
}

export function fromTTC_UnitPriceToHT(line) {
    // not implemented yet
    const t = (line.unitPrice * 100) / (100 + line.vatRate);
    debugger;
    return t;
    return (line.unitPrice * 100) / (100 + line.vatRate);
}
